import { render, staticRenderFns } from "./userVerificacode.vue?vue&type=template&id=4df04349"
import script from "./userVerificacode.vue?vue&type=script&lang=js"
export * from "./userVerificacode.vue?vue&type=script&lang=js"
import style0 from "./userVerificacode.vue?vue&type=style&index=0&id=4df04349&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default})
